<template>
  <div class="unsubscribe-page">
    <div class="card">
      <div v-if="loading" class="loading">
        Processing...
      </div>
      <div v-else-if="success" class="success">
        <h2>Unsubscribed</h2>
        <p>You have been successfully unsubscribed from our mailing list.</p>
        <p>We're sorry to see you go!</p>
      </div>
      <div v-else class="error">
        <h2>Error</h2>
        <p>{{ error }}</p>
        <p>Please try again or contact support.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { UNSUBSCRIBE_MUTATION } from "../graphql/unsubscribe";

export default {
  name: "Unsubscribe",
  data() {
    return {
      loading: true,
      success: false,
      error: null,
    };
  },
  async mounted() {
    const email = this.$route.query.email;
    if (!email) {
      this.error = "Invalid unsubscribe link. Email is missing.";
      this.loading = false;
      return;
    }

    try {
      const result = await this.$apollo.mutate({
        mutation: UNSUBSCRIBE_MUTATION,
        variables: {
          email: email,
        },
      });

      if (result.data.unsubscribe) {
        this.success = true;
      } else {
        this.error = "Could not find an account with this email address.";
      }
    } catch (err) {
      this.error = "An error occurred. Please try again later.";
      console.error(err);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.unsubscribe-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f6f8;
  font-family: 'Roboto', sans-serif;
}

.card {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
}

h2 {
  color: #141a46;
  margin-bottom: 20px;
}

p {
  color: #727272;
  margin-bottom: 15px;
  line-height: 1.5;
}

.success h2 {
  color: #4caf50;
}

.error h2 {
  color: #f44336;
}

.loading {
  color: #141a46;
  font-weight: bold;
}
</style>
